import React, { useState } from "react";
import { Modal } from "react-materialize";
import { useNavigate, useParams } from "react-router-dom";
import BidingHistory from "../../table/BidHistory";
import { capitalizeFirstLetter } from "../../../../../../helpers/helpers";

function MobileLotInformation({ offers, bidderDetails }) {
  const { catalogueId } = useParams();
  const navigate = useNavigate();
  const [isOpenModel, setIsOpenModel] = useState(false);

  return (
    <div
      className="flex column gap-10px"
      style={{ width: "250px", padding: "10px" }}
    >
      <h6 className="margin-0px mobile-information">
        Lot No :{" "}
        <span className="cercle-purple-text">{offers?.offerNumber}</span>
      </h6>
      <h6 className="margin-0px mobile-information">
        Starting Price :{" "}
        <span className="cercle-purple-text">{offers?.startingPrice}</span>
      </h6>
      <h6 className="margin-0px mobile-information">
        Minimum Bid :{" "}
        <span className="cercle-purple-text">{offers?.minimumBid}</span>
      </h6>
      <button
        className={`button-style pointer font-14px white-text cercle-purple`}
        style={{
          padding: "8px",
        }}
        onClick={() => navigate(`/catalogue-live-room/${catalogueId}`)}
      >
        Catalogue
      </button>
      <button
        className={`button-style pointer font-14px white-text cercle-purple`}
        style={{
          padding: "8px",
        }}
        onClick={() => setIsOpenModel(true)}
      >
        Bid History
      </button>
      {/* <button
        className={`button-style valign-wrapper pointer font-16px white-text black`}
        style={{
          padding: "10px",
          gap: "5px",
        }}
      >
        <span className="material-icons-outlined font-20px">
          settings_suggest
        </span>
        <span className="small-text">Auto Bids</span>
      </button> */}
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        style={styles.modal}
        className="modelAccount"
        id="modalView-details"
        open={isOpenModel}
        options={{ onCloseEnd: () => setIsOpenModel(false) }}
      >
        <h5 className="margin-0px flex justify-center">Bid History</h5>
        <div
          className="valign-wrapper space-between mt-1 mr-1 small-text"
          style={{ marginBottom: "0.5rem" }}
        >
          <span>
            Lot {offers?.offerNumber} :{" "}
            {offers?.scrapDetails?.type} (
            <span className="cercle-purple-text">
              {offers?.scrapDetails?.quantity} /{" "}
              {capitalizeFirstLetter(offers?.scrapDetails?.unit)}
            </span>
            ){" "}
          </span>
          <span className="small-text red-text">Last 10 Highest bids </span>
        </div>
        <BidingHistory bidderDetails={bidderDetails} isMobileView={true}/>
      </Modal>
    </div>
  );
}
const styles = {
  modal: {
    maxHeight: "1000px",
  },
};

export default MobileLotInformation;
